import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import styled from "styled-components";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { useSelections } from "../../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetalheRanking({ app, config }) {
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [selectedValue, setSelectedValue] = useState("Total Eans Positivados");

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_PDV_TOP10")
        : null;
      setSelectedValue(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      console.log(distributors);
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  const handleChange = (event) => {
    if (event.target.value) {
      app.field("Tipo_PDV_TOP10").selectMatch(event.target.value);
      setSelectedValue(event.target.value);
    }
  };

  return (
    <>
      <FormControl className="container-form-control">
        <RadioGroup
          row
          defaultValue={"Total Eans Positivados"}
          value={selectedValue}
          onChange={handleChange}
          sx={{ marginLeft: "20px", marginBottom: "16px", marginTop: "16px" }}
        >
          <FormControlLabel
            value="Total Eans Positivados"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="Total EANs Positivados"
          />

          <FormControlLabel
            value="EANs não Positivados"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="EANs não Positivados"
          />

          <FormControlLabel
            value="Mix Obrigatorio Positivados"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="Mix Obrigatorio Positivados"
          />

          <FormControlLabel
            value="Mix não Positivados"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#0DA9D5",
                  "&.Mui-checked": {
                    color: "#0DA9D5",
                  },
                }}
              />
            }
            label="Mix não Positivados"
          />
        </RadioGroup>
      </FormControl>

      <LayoutCardsWrapper>
        <LayoutCardWrapper>
          <div style={{ width: "100%", height: "90%" }}>
            <Card
              app={app}
              style={{ width: "100%", height: "100%" }}
              exportContainer
              exportTable
              exportTableId="PaPh"
            >
              <NativeObject app={app} key="PaPh" reference={{ id: "PaPh" }} />
            </Card>
          </div>
        </LayoutCardWrapper>
      </LayoutCardsWrapper>
    </>
  );
}

DetalheRanking.defaultProps = {
  app: null,
  config: {},
};

DetalheRanking.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetalheRanking;
